import { DOMAIN_TITLE } from '@/config/env';

export const routes = [
    {
        path: '/login',
        name: 'Login',
        component: resolve => require(['@/pages/Login.vue'], resolve),
        meta: { title: `${DOMAIN_TITLE} | Login`, auth:false, front: true }
    },
    {
        path: '/',
        component: resolve => require(['@/pages/Index.vue'], resolve),
        meta: { auth:true, front: false },
        children: [
            ,
            {
                path: '/',
                redirect:'accueil',
            }, 
            {
                path: 'accueil',
                name: 'home',
                component: resolve => require(['@/pages/Home.vue'], resolve),
                meta: { auth:false, front: true }
            },
            {
                path: 'nous',
                name: 'us',
                component: resolve => require(['@/pages/Content.vue'], resolve),
                meta: { auth:false, front: true, id: 'us' }
            },            
            {
                path: 'activites',
                name: 'activity',
                component: resolve => require(['@/pages/Activity.vue'], resolve),
                meta: { auth:false, front: true, id: 'activity' }
            },            
            {
                path: 'rejoindre',
                name: 'join',
                component: resolve => require(['@/pages/Content.vue'], resolve),
                meta: { auth:false, front: true, id: 'join' }
            },        
            {
                path: 'contact',
                name: 'contact',
                component: resolve => require(['@/pages/Contact.vue'], resolve),
                meta: { auth:false, front: true , id: 'contact'   }
            },               
            {
                path: 'cgu',
                name: 'cgu',
                component: resolve => require(['@/pages/Content.vue'], resolve),
                meta: { auth:false, front: true, id: 'cgu'  }
            },               
            {
                path: 'mentions-legales',
                name: 'mentions',
                component: resolve => require(['@/pages/Content.vue'], resolve),
                meta: { auth:false, front: true, id:'mentions' }
            },   
            {
                path: 'communaute',
                name: 'community',
                component: resolve => require(['@/pages/Community.vue'], resolve),
                meta: { auth:true, front: true, id:'community' }
            },                
        ]
    },    
    
    {
        path: '*',
        component: resolve => require(['@/pages/404.vue'], resolve),
        meta: { title: `${DOMAIN_TITLE} | Erreur 404` }
    }
];



// WEBPACK FOOTER //
// ./src/router/routes.js